import {
  Alert
} from "../model/alert/alert.model";
import { ts2json } from "../util/json-2ts";
import * as OU from "../util/object-utils";
import * as UXActions from "./ux.actions";

export interface UXContext {
  selectedAlert: Alert;
  deSelectedAlert: Alert;
  activeDashboard: string;
  flags: UXActions.Flags;
}

const initialState: UXContext = {
  selectedAlert: null,
  deSelectedAlert: null,
  activeDashboard: null,
  flags: {}
};

function setFlag(state: UXContext, flag: string, value: any): UXContext {
  return {
    ...state,
    flags: {
      ...state.flags,
      [flag]: value
    }
  };
}

function clearFlag(state: UXContext, flag: string): UXContext {
  const { [flag]: flagValue, ...newFlags} = state.flags;
  return {
    ...state,
    flags: newFlags
  };
}

// NxRx removes the typescript types (for some stupid reason)
// so we deserialize this back to JSON
// and then things picking it up at the other end will have to re-parse it.
// Fortunately this is not a high volume method or that would be entirely absurd...
export function uxReducer(state = initialState, action: UXActions.UXActions): UXContext {
  switch (action.type) {

    case UXActions.DASHBOARD_ACTIVATED:
      return {
        ...state,
        activeDashboard: action.payload
      };

    case UXActions.ALERT_SELECTED:
      return {
        ...state,
        deSelectedAlert: null,
        selectedAlert: ts2json(action.payload)
      };

    case UXActions.ALERT_DESELECTED:
      return {
        ...state,
        deSelectedAlert: ts2json(action.payload),
        selectedAlert: null
      };

    case UXActions.UX_RESET:
      return OU.copyObjectWithoutNullsOrGraphQLMetaKeys(action.context) as UXContext;

    case UXActions.SET_FLAG:
      return setFlag(state, action.payload.flag, action.payload.value);
    case UXActions.CLEAR_FLAG:
      return clearFlag(state, action.payload.flag);

    default:
      return state;
  }
}
